import React from 'react';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../../../shared/components/table-components';

const HeaderRow = () => {
  return (
    <GridTableRow variant="header">
      <GridTableCell>№</GridTableCell>
      <div />
      <GridTableCell>Name</GridTableCell>
      <div />
      <GridTableCell>Link</GridTableCell>
      <div />
    </GridTableRow>
  );
};

export { HeaderRow };
